// extracted by mini-css-extract-plugin
module.exports = {"body_container":"_1GU3XK5Zed5DXvof2l_1eZ"};